import "./myPatients.scss";
import React, { useEffect, useState } from "react";
import { Box, Card, Container, CardContent } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PageLayoutDoctor } from "../../../components/page/page-layout-doctor";
import MyPatientsListToolbar from "../../../components/doctor/my-patients/my-patients-list-toolbar";
import { MyPatientsSearch } from "../../../components/doctor/my-patients/my-patients-search";
import { MyPatientsListResults } from "../../../components/doctor/my-patients/my-patients-list-results";
import { consultaPacientes } from "../../../services/MyPatientsServices";
import { getDecryptedDataFromSessionStorage } from "../../../utils";
import { SECRET_KEY } from "../../../constants/encriptKey";

const MyPatients = () => {
  const navigate = useNavigate();
  const [listPatients, setListPatients] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const data = getDecryptedDataFromSessionStorage(SECRET_KEY);
  const { idMedico } = data
  
  const executeAction = (action, data) => {
    navigate("/my-patients/new");
  };

  const fetchData = async () => {
    try {
      const criteria = {
        idMedico: idMedico,
        nombre: "",
        apellido: "",
        tipoDocumento: "",
        nroDocumento: "",
        page: 1,
      };

      const res = await consultaPacientes(criteria);
      setListPatients(res.result.pacientes);
    } catch (error) {
      setErrorMessage(error.toString());
    } finally {
      setLoadingData(false);
    }
  };


  useEffect(() => {
    fetchData();
  }, []);




  return (
    <PageLayoutDoctor>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 2,
        }}
      >
        <Container maxWidth={false}>
          <Card
            sx={{
              border: "0.5px solid #dddddd",
              padding: "1px",
              boxShadow: "1px 1px #d5d5d5",
            }}
          >
            <CardContent>
            <MyPatientsListToolbar onAddPatientClick={executeAction} /> {/* handleAddPatientClick */}
              <Box sx={{ mt: 3 }}>
                <MyPatientsSearch onSearch={setListPatients} />
                <MyPatientsListResults
                  patients={listPatients}
                  loading={loadingData}
                />
              </Box>
            </CardContent>
          </Card>
        </Container>
      </Box>
    </PageLayoutDoctor>
  );
};

export default MyPatients;
